
import { type FC, type PropsWithChildren } from 'react';

import { IconButton } from '@eneco/sparky';
import { CloseIcon } from '@eneco/sparky/icons';

/** Accessible name when CMS `triggerText` is missing — keep Dutch (WCAG 4.1.2 / 2.4.6). */
export const NAVIGATION_CLOSE_BUTTON_LABEL = 'Afsluiten';

interface Props {
  label?: string;
  onClick?: () => void;
}

export const NavigationCloseButton: FC<PropsWithChildren<Props>> = ({ label, onClick }) => (
  <IconButton label={label?.trim() || NAVIGATION_CLOSE_BUTTON_LABEL} onClick={onClick}>
    <CloseIcon color="iconSecondary" />
  </IconButton>
);
